import { get, map } from 'lodash';

export default class MongoPageable<T> {
  content: T[];
  empty: boolean;
  first: boolean;
  last: boolean;
  // The current page number
  number: number;
  // The number of elements in this response
  numberOfElements: number;
  // The max number of elements in a page
  size: number;
  totalElements: number;
  totalPages: number;

  constructor(json: any, ContentClass: new (itemJson: any) => T) {
    this.content = map(
      get(json, 'content'),
      (itemJson: any) => new ContentClass(itemJson)
    );
    this.empty = !!get(json, 'empty');
    this.first = !!get(json, 'first');
    this.last = !!get(json, 'last');
    this.number = get(json, 'number');
    this.numberOfElements = get(json, 'numberOfElements');
    this.size = get(json, 'size');
    this.totalElements = get(json, 'totalElements');
    this.totalPages = get(json, 'totalPages');
  }
}
